import React, { useState, useEffect } from "react";
import axios from "axios";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import { useNavigate, useLocation } from "react-router-dom";

const Redirect = ({ BASEURL }) => {
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const location = useLocation();
  const stateRole = location.state?.Role;
  const stateSite = location.state?.URL;
  const stateId = location.state?.id;

  // console.log('state id:::::',stateId,stateSite)

  // console.log(stateId);

  const getDeviceId = async () => {
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    return result.visitorId;
  };

    const handleRegister = async () => {
        navigate('/register', { state: { role: stateRole, site: stateSite } })
    }


  const handleRedirect = async (stateURL) => {
    setError(null);
    const deviceId = await getDeviceId();
    const token = localStorage.getItem("token");
    try {
      if (!token) {
        throw new Error("Token not received from login response");
      }

      // Get redirect URL
      const response = await axios.post(
        `${`http://localhost:5002/cred`}/redirect`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "device-id": deviceId,
          },
        }
      );

      const url = response.data;

      if (!url || !deviceId) {
        setError(`Anything is wrong, Please Login again!`);
        setTimeout(() => {
          navigate("/", { replace: true });
        }, 1000);
        return;
      }

      if (url.includes(stateURL)) {
        window.location.href = `${stateURL}?token=${encodeURIComponent(
          token
        )}&id=${stateId}`;
        //window.location.href = `http://localhost:3000/?token=${encodeURIComponent(token)}&id=${stateId}`;
      } else {
        setError(`Anything is wrong, Please Login again!`);
        setTimeout(() => {
          navigate("/", { replace: true });
        }, 1000);
        return;
      }
    } catch (error) {
      if (error.response) {
        setError(error.response.data.message);
      } else {
        setError(error.message);
      }
    }
  };
  const onHandle = () => {
    // alert("hii");
    // navigate("/users");
    navigate("/dashboard");
  };

  return (
    <div className="relative flex flex-col justify-center items-center bg-gradient-to-t from-custom-dark-image to-custom-green-image h-screen overflow-y-hidden">
      {error && (
        <div
          className="bg-red-100 border border-red-400 text-red-700 px-3 py-2 rounded mt-4 w-2/4 absolute top-2 "
          role="alert"
        >
          <strong className="font-bold">Error!</strong>
          <span className="block sm:inline pl-3">{error}</span>
          <span className="absolute top-0 bottom-0 right-0 px-3 py-2">
            <svg
              className="fill-current h-6 w-6 text-red-500"
              role="button"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              onClick={() => setError(null)} // Clear error on close
            >
              <title>Close</title>
              <path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z" />
            </svg>
          </span>
        </div>
      )}
      <button className="bg-white" onClick={onHandle}>
       Users List..
      </button>
      <div className="w-full max-w-sm bg-white p-6 rounded-lg shadow-md">
        <h2 className="text-2xl font-extrabold text-center mb-6 text-custom-green-image">
          Redirect URL
        </h2>
        <div className="flex flex-col gap-4">
          {stateSite.map((i, index) => {
            return (
              <button
                key={index}
                onClick={() => handleRedirect(i.siteURL)}
                className="w-full bg-gradient-to-t from-custom-dark-image to-custom-green-image text-white font-bold py-2 px-4 rounded-lg transition duration-300"
              >
                {i.siteName}
              </button>
            );
          })}

          {stateRole !== "User" && (
            <div className="flex gap-2">
              <button
                onClick={handleRegister}
                className="w-full text-nowrap border border-[#083A35] hover:bg-gradient-to-t from-custom-dark-image to-custom-green-image hover:text-white  text-[#083A35] font-bold py-2 px-4 rounded-lg transition duration-300"
              >
                {stateRole === "Admin" && "Create User"}{" "}
                {stateRole === "Super-Admin" && "Create Admin"}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Redirect;

